import { Component, computed, EventEmitter, inject, Input, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { SubscriptionComponent } from '../../../../shared/helpers/subscription.component';
import { SearchDoctorSpecializationStore } from './search-doctor-specialization.store';
import { DoctorSpecializationObject } from '@libs/types/src/services/object-type/vzp/doctor-specialization.object';
import { SelectInputComponent } from '../../../../../components/kit/input/select-input/select-input.component';
import { InfiniteScrollStore } from '../../../../shared/store/common/infinite-scroll.store';
import { FilterBuilder } from '@libs/shared/utils/grid.builder';
import { specializationFrag } from './search-doctor-specialization.query';

@Component({
    selector: 'app-search-doctor-specialization',
    templateUrl: 'search-doctor-specialization.component.html',
    styleUrls: ['search-doctor-specialization.component.scss'],
    providers: [SearchDoctorSpecializationStore],
    imports: [
        SelectInputComponent,
    ],
})
export class SearchDoctorSpecializationComponent extends SubscriptionComponent {

    protected readonly store = inject(SearchDoctorSpecializationStore);

    @Input() form!: FormGroup;
    @Input() id = 'doctorSpecialization';
    @Input() label = 'folderContact.fields.doctorSpecialization';
    @Input() serviceId: number | null = null;

    @Output() selected = new EventEmitter<DoctorSpecializationObject>();

    protected specializations = computed(() => {
        return new InfiniteScrollStore(
            this.store.api.getDoctorSpecializations,
            FilterBuilder.singlePage({
                sort: { column: 'code', direction: 'ASC' },
            }),
            true,
            specializationFrag,
            undefined,
            true,
            'code',
        );
    });

}
